import { QueryClient } from "@tanstack/react-query";

import { ApiRequestError } from "../api/apiClient.js";

/**
 * Abgelehnte Zugriffe und fehlende Datensätze sind normale Antworten und werden nicht
 * wiederholt — nur technische Aussetzer bekommen einen zweiten Versuch.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          if (error instanceof ApiRequestError && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
